/**
 * Profile Feature Routes
 */
import type { RouteRecordRaw } from 'vue-router';
import i18next from 'i18next';

export const profileRoutes: RouteRecordRaw[] = [
  {
    path: '/profile',
    name: 'profile',
    component: () => import('./views/ProfileView.vue'),
    meta: {
      title: () => i18next.t('profile.pageTitle'),
    },
  },
];
